module.exports = __webpack_public_path__ + "img/down.9c0c7f0f.svg";